import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import { goToLink } from '../../projectData';
/**
 * RedemReConfirm component
 * Displays a confirmation page for redemption, showing transaction details, address, and bank info. Allows user to confirm or go back.
 */

const RedemReConfirm = () => {
    const location = useLocation();
    const transactionDetail = location.state?.detailData;
    const navigate = useNavigate()
    const [giftItem, setGiftItem] = useState(location.state?.itemValue)
    useEffect(() => {
        if (transactionDetail?.address1) {
            setGiftItem(prevGiftItem => ({
                ...prevGiftItem,
                userAddress: transactionDetail
            }));
        }
        if (transactionDetail?.api_nameAtBank) {
            setGiftItem(prevGiftItem => ({
                ...prevGiftItem,
                userBank: transactionDetail
            }));
        }
    }, [transactionDetail]);
    return (
        <>
            <div className="container mt-4">

                <div className="row">
                    <div className="col-md-6 mt-10 pancard-data">
                        <div className="text-center mb-7">
                            <img
                                width="50%"
                                alt="icon"
                                src={toAbsoluteUrl("/media/images/reconfirmation-min.png")}
                            />
                        </div>
                    </div>

                    <div className="col-md-6 mt-2 pancard-data">
                        <div className="mt-2">
                            <h1 className="mb-5">Re-Confirm</h1>
                            {transactionDetail?.address1 && <p>Your gift will be delivered to the address you confirm here.</p>}
                            {transactionDetail?.api_nameAtBank && <p>Your DBT will be settled in the bank account.</p>}
                            {transactionDetail?.api_nameAtBank && <p>Name At Bank: {transactionDetail?.api_nameAtBank}</p>}
                            {transactionDetail?.account_number && <p>Account Number: {transactionDetail?.account_number}</p>}
                            {transactionDetail?.ifsc_code && <p>IFSC: {transactionDetail?.ifsc_code}</p>}
                            {transactionDetail?.mobile_no && <p>Mobile Number: {transactionDetail?.mobile_no}</p>}


                            {transactionDetail?.address1 || transactionDetail?.city || transactionDetail?.pincode ? (
                                <div className="col-sm-12 mb-4">
                                    <p className='fw-semibold fs-5'>Product Name : <span className='fw-semibolder text-danger'>{giftItem?.gift_name}</span></p>
                                    <p className='fw-semibold fs-5'>Dispatch Address :</p>
                                    <div
                                        style={{ border: transactionDetail?.default ? '2px solid #f1416c' : '1px solid #E6E6E6' }}
                                        className="card p-4 position-relative"
                                    >

                                        <div className="card-title m-0 d-flex align-items-center gap-4">
                                            <div
                                                className="symbol d-flex align-items-center justify-content-center position-relative"
                                                style={{
                                                    width: '45px',
                                                    height: '45px',
                                                    borderRadius: '50%',
                                                    border: `2px solid ${Number(transactionDetail?.status) === 1 ? '#28a745' : '#828282'}`, // Green for verified, gray otherwise
                                                }}
                                            >
                                                {transactionDetail?.address_type?.toLowerCase() === 'home' ? (
                                                    <img style={{ width: '20px', height: "20px" }} src={toAbsoluteUrl('/media/images/redem-home.png')} alt='redem-home' />
                                                ) : (transactionDetail?.address_type?.toLowerCase() === 'other' ? (
                                                    <img style={{ width: '20px', height: "20px" }} src={toAbsoluteUrl('/media/images/redem-other.png')} alt='redem-other' />) :
                                                    <>
                                                        <img style={{ width: '20px', height: "20px" }} src={toAbsoluteUrl('/media/images/redem-office.png')} alt='redem' />
                                                    </>
                                                )}

                                                {/* Checkmark for verified addresses */}

                                                <i
                                                    className="bi bi-check-circle-fill position-absolute"
                                                    style={{
                                                        fontSize: '13px',
                                                        top: '-1px',
                                                        right: '-1px',
                                                        backgroundColor: '#fff',
                                                        borderRadius: '50%',
                                                        color: Number(transactionDetail?.status) === 1 ? '#28a745' : '#828282',
                                                    }}
                                                ></i>

                                            </div>


                                            {/* Replaced invalid anchor (href="#") with an accessible button */}
                                            <button
                                                type="button"
                                                className="fs-3 fw-semibold text-black text-capitalize btn btn-link p-0"
                                                aria-label={`Address type: ${transactionDetail?.address_type}`}
                                                onClick={(e) => e.preventDefault()}
                                            >
                                                {transactionDetail?.address_type}
                                            </button>


                                        </div>
                                        <div className="card-body p-2 row">
                                            <div className="col-10">
                                                <p className="fs-6 ms-2 m-0 mt-2">
                                                    {transactionDetail?.address1 && `${transactionDetail.address1},`}
                                                    {transactionDetail?.address2 && `${transactionDetail.address2}`}
                                                    {(transactionDetail?.address1 || transactionDetail.address2) && <br />}
                                                    {transactionDetail?.address3 && `${transactionDetail.address3}, `}
                                                    {transactionDetail?.landmark && `${transactionDetail.landmark}`}
                                                    {(transactionDetail?.address3 || transactionDetail.landmark) && <br />}
                                                    {transactionDetail?.city && `${transactionDetail.city}, `}
                                                    {transactionDetail?.district && `${transactionDetail.district}, `}
                                                    {transactionDetail?.state && `${transactionDetail.state}, `}
                                                    {transactionDetail?.pincode && `${transactionDetail.pincode}`}
                                                </p>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            ) : null}

                            <div className="btns cn-btn mt-15 d-flex">
                                <button className="btn bgdark-blue text-white" onClick={() => navigate(-1)} >
                                    No
                                </button>
                                <button className="btn red-btn text-white"
                                    style={{
                                        backgroundColor: "red-btn text-white",
                                        color: "white",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => goToLink(navigate, '/customer/redem-addtocart-detail', giftItem)}
                                // disabled={isLoading}
                                >
                                    {/* {isLoading ? "Loading..." : "Yes"} */}Yes
                                </button>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </>
    )
}

export default RedemReConfirm